import type { ComponentProps } from 'react'
import ZipcodeChecker from '../components/ZipcodeChecker'

type Props = ComponentProps<typeof ZipcodeChecker>

export default function Step0_ZipcodeChecker(props: Props) {
  return <ZipcodeChecker {...props} />
}

